import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { QcsLoadingButton } from '../../common/basic/QcsLoadingButton';
import { FilterPanelFooter, FilterPanelScroll } from '../AnalyticsStyles';

interface Props {
  formValues: Record<string, unknown>;
  FilterBar: FC;
}

export const ExplorerFilterForm: FC<Props> = ({ formValues, FilterBar }) => {
  const { t } = useTranslation();
  const { handleSubmit, setValues, isValid } = useFormikContext();

  useEffect(() => {
    setValues(formValues);
  }, [formValues, setValues]);

  return (
    <>
      <FilterPanelScroll>
        <FilterBar />
      </FilterPanelScroll>
      <FilterPanelFooter>
        <QcsLoadingButton variant="contained" onClick={() => handleSubmit()} disabled={!isValid}>
          {t('analytics.dashboard.apply')}
        </QcsLoadingButton>
      </FilterPanelFooter>
    </>
  );
};
